// useForm.js

import { useState, useEffect } from 'react';
import { getCustomerData, getPreviousLedgerDetails } from '../../Service/ApiService';
import { useNavigate } from '../../../node_modules/react-router-dom/dist/index';
import { getDashboardRouteForUser } from 'utils/menuConfig';
const LedgerPreviousYearDetailsController = (initialState, validate) => {
  const [formData, setFormData] = useState(initialState);
  const [customeroptions, setCustomerOptions] = useState([]);
  const [ledgerData, setLedgerData] = useState([]);
  const [cloading, setcLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const user = JSON.parse(localStorage.getItem('user'));
  const storedLedgerData = JSON.parse(localStorage.getItem('ledgerData'));
  const [searchText, setSearchText] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    getCustomer();
  }, [searchText]);

  useEffect(() => {
    fetchLedgerDetailsData();
  }, []);

  const handleInputChange = (inputValue) => {
    setSearchText(inputValue);
  };

  const handleViewClick = () => {
    navigate(getDashboardRouteForUser());
  };

  const getCustomer = async () => {
    try {
      setcLoading(true);
      // console.log("USER",user);
      const response = await getCustomerData(user.userCode, searchText);
      // console.error('Return Response:', response);
      if (response && response.success === 'true') {
        setCustomerOptions([]);
        // comment this functionality for remove duplicate partycode data - 6 June
        // const customerOptions = response.customerList.map((item) => ({
        //   value: item.partyCode.toString(),
        //   label: item.partyName+"-"+item.city+"-"+item.partyCode.toString()
        // }));
        // setCustomerOptions(customerOptions);
        const uniqueCustomerOptions = response.customerList.reduce((uniqueList, currentItem) => {
          // Check if the partyCode of the current item is already present in the unique list
          const existingItem = uniqueList.find((item) => item.value === currentItem.partyCode.toString());

          // If the partyCode is not already in the unique list, add it
          if (!existingItem) {
            uniqueList.push({
              value: currentItem.partyCode.toString(),
              label: currentItem.partyName + '-' + currentItem.city + '-' + currentItem.partyCode.toString()
            });
          }

          return uniqueList;
        }, []);
        setCustomerOptions(uniqueCustomerOptions);
      }
      setcLoading(false);

      // setFormData({
      //   ...formData,
      //   ['customer']: customerString,
      // });
    } catch (error) {
      // console.error('Error during login:', error);
      setcLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate(formData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      //fetchLedgerData(formData.customer.value); // Use the new function
    }
  };

  const fetchLedgerDetailsData = async () => {
    try {
      setcLoading(true);
      const response = await getPreviousLedgerDetails(
        storedLedgerData.partyCode,
        storedLedgerData.month,
        storedLedgerData.year,
        storedLedgerData.opening
      );
      setLedgerData([]);
      if (response && response.success === 'true') {
        setLedgerData(response.data);
      } else {
        setLedgerData([]);
      }
      setcLoading(false);
    } catch (error) {
      console.error('Error fetching ledger data:', error);
      setcLoading(false);
    }
  };

  const handleCustomerChange = (e) => {
    if (e) {
      setFormData({
        ...formData,
        ['customer']: e // Update formData with the selected customer
      });

      setErrors({
        ...errors,
        ['customer']: '' // Clear any existing errors
      });
    } else {
      setFormData({
        ...formData,
        ['customer']: null // Clear the customer field in formData
      });

      setErrors({
        ...errors,
        ['customer']: '' // You can set a validation error or reset it
      });

      setLedgerData([]);
    }
  };

  return {
    ledgerData,
    formData,
    user,
    cloading,
    errors,
    customeroptions,
    handleCustomerChange,
    handleSubmit,
    handleInputChange,
    handleViewClick
  };
};

export default LedgerPreviousYearDetailsController;
